import { render, staticRenderFns } from "./Aliens.vue?vue&type=template&id=6e63393f&scoped=true&"
import script from "./Aliens.vue?vue&type=script&lang=js&"
export * from "./Aliens.vue?vue&type=script&lang=js&"
import style0 from "./Aliens.vue?vue&type=style&index=0&id=6e63393f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e63393f",
  null
  
)

export default component.exports